export const LOCATION_DETAIL_SECTIONS = [
  "associatedLocations",
  "postedJobs",
  "invoices",
  "payments",
  "placementFees",
  "cancellations",
  "blocksFavourites",
  "notes",
  "feedback",
  "adminActions"
];

export const createCollapsedLocationSections = () =>
  LOCATION_DETAIL_SECTIONS.reduce((sections, key) => {
    sections[key] = true;
    return sections;
  }, {});

export const nextLocationSectionState = (sections, key) => !sections[key];
